export default [
  {
    path: 'templates',
    children: [
      {
        name: 'templates',
        path: '',
        component: () => import('./TemplatesList.vue'),
        meta: { title: 'Templates', guard: false }
      },
      {
        name: 'create-template',
        path: 'create',
        component: () => import('./TemplateForm.vue'),
        meta: { title: 'New Template' },
        props: {
          type: 'New'
        }
      },
      {
        name: 'edit-template',
        path: ':id/edit',
        component: () => import('./TemplateForm.vue'),
        meta: { title: 'Edit Template' },
        props: (route) => ({
          type: 'Edit',
          id: route.params.id
        })
      },
      {
        name: 'view-template',
        path: ':id/view',
        component: () => import('./TemplateView.vue'),
        meta: {
          title: 'View Template'
        },
        props: (route) => ({
          id: route.params.id
        })
      }
    ]
  },
]
